import { CHAT_ERROR_CODES, QUOTA_ERROR_CODES } from '@shared/constants/error-codes';
import { ApiError } from '@/lib/api-error';

const QUOTA_ERROR_MESSAGES: Record<string, string> = {
  [QUOTA_ERROR_CODES.QUOTA_NOT_CONFIGURED]: 'Aucun quota n’est configuré pour cet utilisateur.',
  [QUOTA_ERROR_CODES.QUOTA_CONFIG_REQUIRED]: 'Une configuration de quota est requise pour un compte démo.',
  [QUOTA_ERROR_CODES.QUOTA_INVALID_RENEWAL_DATE]: 'La date de renouvellement doit être dans le futur.',
  [CHAT_ERROR_CODES.QUOTA_EXCEEDED]: 'Le quota de tokens a été atteint.',
};

function extractErrorCode(error: unknown): string | null {
  if (error instanceof ApiError && error.code) {
    return error.code;
  }

  if (error && typeof error === 'object' && 'code' in error && typeof error.code === 'string') {
    return error.code;
  }

  if (
    error &&
    typeof error === 'object' &&
    'error' in error &&
    error.error &&
    typeof error.error === 'object' &&
    'code' in error.error &&
    typeof error.error.code === 'string'
  ) {
    return error.error.code;
  }

  return null;
}

export function getQuotaErrorMessage(error: unknown): string {
  const code = extractErrorCode(error);

  if (code && code in QUOTA_ERROR_MESSAGES) {
    return QUOTA_ERROR_MESSAGES[code]!;
  }

  return 'Une erreur est survenue lors de la gestion du quota. Réessayez dans un instant.';
}
